<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container"></div>
    </div>
    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("media.media") }}</div>

        <div class="mb33">
          <div class="self_media_widthHeight">
            <img src="../../public/static/img/media/self_media.png" alt="" />
          </div>

          <div class="self_media">
            <div class="self_media_title">
              <div class="self_media_title_font">
                {{ $t("media.self") }}
              </div>
              <div class="self_content_font">
                {{ $t("media.self_content") }}
              </div>
            </div>
            <div class="learnMore ml72" @click="$router.push('travel')">
              {{ $t("media.more") }}
              <div class="goLearnMore">
                <img
                  class="mt13"
                  src="../../public/static/img/home/learnMore.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div class="dataMediaStyle">
          <div class="dataMedia_widthHeight">
            <img :src="$t('picture.dataMedia')" alt="" />
          </div>
        </div>

        <div class="dataMediaTitle">
          <div class="dataMediaTitleFont">
            {{ $t("media.dataMedia") }}
          </div>
          <div class="dataMediaContentFont">
            {{ $t("media.dataMediaContent") }}
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f2f2f2">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("media.dataSource") }}</div>
        <div class="data_overview">
          <div class="overviewImgWidthHeight">
            <img src="../../public/static/img/media/overview.png" alt="" />
          </div>
          <div class="overview">
            <div class="overviewTitleFont">
              {{ $t("media.overview") }}
            </div>
            <div>
              <div class="triangle_explain mb27">
                <div class="triangle mb10"></div>
                <div class="overviewContent">
                  {{ $t("media.overview1") }}
                </div>
              </div>
              <div class="triangle_explain mb27">
                <div class="triangle mb10"></div>
                <div class="overviewContent">
                  {{ $t("media.overview2") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between">
          <div class="data_value">
            <img :src="$t('picture.mediaValue')" alt="" />
          </div>
          <div class="data_scarce">
            <img :src="$t('picture.mediaLack')" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("media.DMP") }}</div>
        <div class="DMP_media">
          <div class="triangle_explain mr126 w500">
            <div class="triangle mt10 mb100"></div>
            <div class="lh32">
              {{ $t("media.DMP_content") }}
            </div>
          </div>

          <div class="mediaDMP">
            <img src="../../public/static/img/media/DMP.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f2f2f2">
      <div class="banner_center_media">
        <div class="media_title">
          {{ $t("media.selfSource") }}
          <div class="selfSourceContentFont">
            {{ $t("media.selfSourceContent") }}
          </div>
        </div>

        <div class="self_media_source">
          <div class="self_media_source_img">
            <img
              src="../../public/static/img/media/self_media_source.png"
              alt=""
            />
          </div>

          <div class="exposure_position">
            <div class="exposure_position_font">
              {{ $t("media.position") }}
            </div>
            <div class="exposure_position_explain">
              {{ $t("media.APP") }}
            </div>
          </div>
        </div>

        <div class="customerStyle">
          <div class="cover">{{ $t("media.customers") }}</div>
          <div class="circle1"></div>
          <div class="circle2"></div>
        </div>
        <div class="cover_customer">
          <div class="every_cover_customer bdRight">
            <div class="every_customer_img">
              <img
                class="mb27"
                src="../../public/static/img/media/self.png"
                alt=""
              />
            </div>

            <div class="selfCustomersFont">
              {{ $t("media.selfCustomers") }}
            </div>
            <div class="selfCustomer_font">
              {{ $t("media.selfCustomer_") }}
            </div>
          </div>
          <div class="every_cover_customer bdRight">
            <div class="every_customer_img">
              <img
                class="mb27"
                src="../../public/static/img/media/coop.png"
                alt=""
              />
            </div>
            <div class="selfCustomersFont">
              {{ $t("media.partner") }}
            </div>
            <div class="selfCustomer_font">
              {{ $t("media.partner_") }}
            </div>
          </div>
          <div class="every_cover_customer bdRight">
            <div class="every_customer_img">
              <img
                class="mb27"
                src="../../public/static/img/media/data.png"
                alt=""
              />
            </div>
            <div class="selfCustomersFont">
              {{ $t("media.userData") }}
            </div>
            <div class="selfCustomer_font">
              {{ $t("media.userData_") }}
            </div>
          </div>
          <div class="every_cover_customer">
            <div class="every_customer_img">
              <img
                class="mb27"
                src="../../public/static/img/media/user.png"
                alt=""
              />
            </div>
            <div class="selfCustomersFont">
              {{ $t("media.userProfile") }}
            </div>
            <div class="selfCustomer_font">
              {{ $t("media.userProfile_") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("media.return") }}</div>

        <div class="return_three">
          <div class="every_return">
            <img :src="$t('picture.return1')" alt="" />
          </div>

          <div class="every_return">
            <img :src="$t('picture.return2')" alt="" />
          </div>

          <div class="every_return">
            <img :src="$t('picture.return3')" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.clear {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  background-image: url("http://travelmall.portus.cn/2023/04/7d510c0b6fc64f8daec8e726ca90f746.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
</style>
